import { ReportSettings } from "@/inspection/shared/dtos/ReportSettings";
import { InspectionRepoContainer } from "@/inspection/shared/repositories/InspectionRepoContainer";
import { RequestModel } from "@/shared/model/RequestModel";
import { RequestHandler } from "@/shared/utils/RequestHandler";
import { UserSettings } from "@/storage/UserSettings";
import { ReportSettingsForm } from "../forms/ReportSettingsForm";
import { TypeChecker } from "@/shared/utils/TypeChecker";
import { Report } from "@/inspection/shared/models/Report";

export class ReportSettingsModel extends RequestModel<ReportSettings> {
  private form: ReportSettingsForm;
  public report = new Report();
  private assignmentId = 0;
  private reportType = "";
  private reportId = 0;

  public constructor() {
    super();
    this.form = new ReportSettingsForm();
    this.form.init();
  }

  public load(assignmentId: string, reportType: string, reportId: string) {
    this.assignmentId = parseInt(assignmentId, 10);
    this.reportType = reportType;
    this.reportId = parseInt(reportId, 10);

    RequestHandler.handleModel(
      () =>
        InspectionRepoContainer.reportRepo.getReportSettings(
          UserSettings.getNumericUserId(),
          assignmentId,
          reportType
        ),
      this
    );
  }

  public loadReport() {
    if (!this.assignmentId || !this.reportType) {
      return;
    }

    this.report.init({
      assignmentId: this.assignmentId,
      reportType: this.reportType
    });
    this.report.load();
  }

  public getFormField(fieldname: string) {
    return this.form.getField(fieldname);
  }

  public setFormField(fieldName: string, value: unknown) {
    RequestHandler.handleFormUpdate(
      () => {
        const settings = JSON.stringify(this.form.getData());
        return InspectionRepoContainer.reportRepo.updateReportSettings(
          settings,
          this.assignmentId,
          this.reportType,
          this.reportId
        );
      },
      {
        form: this.form,
        fieldName,
        value
      }
    );
  }

  public from(data: ReportSettings): void {
    for (const key of Object.keys(data)) {
      const value = data[key];

      if (this.form.fieldExists(key)) {
        if (key === "priorityFilter" && TypeChecker.isString(value)) {
          this.form.setFieldValue(key, [value]);
        } else if (key === "hidden_ticket_ids") {
          this.form.setFieldValue(
            key,
            TypeChecker.isArray(value)
              ? value
              : TypeChecker.isString(value)
              ? []
              : []
          );
        } else {
          this.form.setFieldValue(key, value);
        }
      }
    }
  }
}
